import React from "react";
// import { ContainerQuery } from 'react-container-query';
// import classnames from 'classnames';
import { Button as ButtonReactstrap } from "reactstrap";

const Button = (props) => <ButtonReactstrap {...props} />;
export default Button;
// export default Button;
//
// export default props => (
//   <ContainerQuery query={query}>
//     {params => (
//       <div className={classnames(params)}>
//         <div className={classnames('button', props.className)}>
//           {props.children}
//         </div>
//       </div>
//     )}
//   </ContainerQuery>
// );
